import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course02 from "../../../course/course-02/course";
import lesson0207 from "../../../lesson/course-02/lesson-07/lesson";
import lesson0217 from "../../../lesson/course-02/lesson-17/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "73d5d985-aaf6-433e-b0a4-a135e4b9c91d",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0207),
    lesson: lesson0207,
  },
  {
    id: "f9a03dda-cd47-4067-bc2a-22497e2930bd",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0217),
    lesson: lesson0217,
  },
];

export default lessonLinks;
